import React, { useState, useEffect } from "react";
import * as styles from "./top.css";
import ScrollIndicator from "./components/ScrollIndicator/ScrollIndicator";
import { SideMenu } from "./components/SideMenu/SideMenu";
import logoImage from "../../../../assets/top/logonameonlywhite.png";
import centerLogo from "../../../../assets/top/logowhite.png";

export type TopProps = {
  images: string[];
  interval?: number;
  isTopVisible: boolean;
  isHeaderVisible: boolean;
  showTitle: boolean;
};

export const Top: React.FC<TopProps> = ({
  images,
  interval = 5000,
  isTopVisible,
  isHeaderVisible,
  showTitle,
}) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    if (images.length === 0) return;

    const timer = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % images.length);
    }, interval);

    return () => clearInterval(timer);
  }, [images, interval]);

  return (
    <section className={styles.container}>
      <img src={logoImage} alt="Logo" className={styles.logo} />
      
      <button 
        className={styles.menuButton} 
        onClick={() => setIsMenuOpen(!isMenuOpen)}
        aria-label="メニューを開く"
      >
        <span className={styles.menuLine} />
        <span className={styles.menuLine} />
        <span className={styles.menuLine} />
      </button>

      <SideMenu isOpen={isMenuOpen} onClose={() => setIsMenuOpen(false)} />

      {images.map((imgSrc, idx) => (
        <img
          key={imgSrc}
          src={imgSrc}
          alt={`slide-${idx}`}
          className={`${styles.slideImage} ${idx === currentIndex ? styles.active : ""} ${
            isTopVisible ? "" : styles.dimmed
          } ${isHeaderVisible ? styles.headerVisible : ""}`}
        />
      ))}

      <div className={`${styles.centerLogo} ${showTitle ? styles.fadeIn : styles.hidden}`}>
        <div className={styles.centerLogoWrapper}>
          <img src={centerLogo} alt="Center Logo" className={styles.centerLogoImage} />
        </div>
      </div>

      <ScrollIndicator />
    </section>
  );
};

export default Top;
